<template>
  <div class="client-feedback-slider-nine slider lg-container position-relative" id="testimonials">
    <div class="container">
      <h4 class="slider__subtitle">We're proud to work with incredible businesses and bring their visions to life through high-quality print, display, and installation services.</h4>
      <div class="main-content position-relative">
        <div class="clientSliderEight row">
          <carousel :items-to-show="1"
                    :wrap-around="true"
                    :autoplay="6000"
                    :mouseDrag="true"
                    :breakpoints="breakpoints"
                    :pagination="true"
                    class="carousel">
            <slide v-for="testimonial in content" :key="testimonial._id">
              <div class="item">
                <div class="bg-wrapper">
                  <div class="testimonial__content pt-25 pb-30 text-center">
                    <PortableText :value="testimonial.blockText"/>
                  </div>
                  <h6 class="name mt-10 text-center">{{testimonial.person}}</h6>
                </div> <!-- /.bg-wrapper -->
              </div>
            </slide>
            <template #addons>
              <pagination />
            </template>
          </carousel>
        </div>
      </div> <!-- /.main-content -->
    </div>
  </div>
</template>

<script>
import { Carousel, Slide, Pagination } from 'vue3-carousel';
import { PortableText } from "@portabletext/vue";
import sanity from '../../../sanity.js';
const query = `*[_type == "testimonial"]{
  _id,
  person,
  blockText,
  url,
}`;
export default {
  name: 'ClientFeedback',
  components: {
    Carousel,
    Slide,
    Pagination,
    PortableText
  },
  data() {
    return {
      content: [],
      breakpoints: {
        576: {
          itemsToShow: 1,
          snapAlign: 'left'
        },
      },
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.error = this.home = null;
      this.loading = true;
      sanity.fetch(query).then(
          (content) => {
            this.loading = false;
            this.content = content;
          },
          (error) => {
            this.error = error;
          }
      );
    },
  }
}
</script>

<style>
.slider.client-feedback-slider-nine {
  background-color: var(--darkblue);
  .slider__subtitle {
    color: var(--white);
    display: flex;
    font-family: 'gilroy-light', sans-serif;
    font-size: 1.5rem;
    justify-content: center;
    margin: 0 auto 2rem auto;
    max-width: 50rem;
    position: relative;
    text-align: center;
  }
  .clientSliderEight {
    .carousel {
      .testimonial__content {
        font-size: 1.25rem;
        font-family: 'gilroy-light', sans-serif;
        max-height: 38rem;
        overflow-y: scroll;
        @media (min-width: 500px) {
          font-size: 1.5rem;
          max-height: unset;
          overflow-y: unset;
        }
        p {
          color: var(--white);
        }
      }
      .name {
        color: var(--white);
        font-family: 'gilroy-light', sans-serif;
        font-size: 1.25rem;
        margin: 0 0 1rem 0;
      }

      .bg-wrapper {
        background-color: rgba(255, 255, 255, 0.075);
        text-align: left;
      }
    }
  }
}
</style>
